import { AxiosResponse } from 'axios';

import { ApiRoutes } from '@/constant/api';

import { api } from '@/shared/helpers/axios';
import {
	ICreateRateForDateRequest,
	IPersonRatingDetailResponce,
	IPersonRatingResponce,
	IRatedBookingsForModeratorResponse,
} from '@/shared/types/rating.types';

export const ratingApi = {
	getPersonRating: (personId: number): Promise<AxiosResponse<IPersonRatingResponce>> =>
		api.get(`${ApiRoutes.Rating}/${personId}`),
	getPersonRatingDetail: (personId: number) =>
		api
			.get(`${ApiRoutes.Rating}/${personId}/details`)
			.then((res) => (res.data as IPersonRatingDetailResponce[])[0]),
	getRatedBookings: (personId?: number) =>
		api
			.get(`${ApiRoutes.Rating}/for_moderator`, { params: { personId } })
			.then((res) => res.data as IRatedBookingsForModeratorResponse),
	createRateForDate: (payload: ICreateRateForDateRequest) =>
		api.post(`${ApiRoutes.Rating}/factor`, payload),
};
